import {ready} from "../utils/ready.mjs";
import {lazyload} from "../utils/lazyload.js";

;(function () {
    'use strict';

    function loadScroller() {
        lazyload(
            document.querySelectorAll('.js-scroller'),
            function(item) {
                let innerElement = item.querySelector('.js-scroller-content');

                if (typeof(innerElement) !== 'undefined' && innerElement !== null) {

                    let origWidth = innerElement.scrollWidth + (6 * 16); // plus gap

                    const origItems = innerElement.querySelectorAll('.js-scroller-item:not([aria-hidden="true"])');

                    if (origItems.length > 0) {

                        // duplicate items
                        while (innerElement.scrollWidth / item.clientWidth < 2) {
                            Array.prototype.forEach.call(origItems, function (origItem) {
                                let clone = origItem.cloneNode(true);
                                clone.setAttribute('aria-hidden', 'true');
                                innerElement.appendChild(clone);
                            });
                        }

                        let scrollSpeed = 1; // Adjust as needed

                        function autoScroll() {
                            item.scrollLeft += scrollSpeed;

                            // If scrolled past the original content, reset to the beginning of the original content
                            if (item.scrollLeft >= origWidth) {
                                item.scrollLeft = 0;
                            }

                            requestAnimationFrame(autoScroll);
                        }

                        autoScroll();
                    }
                }
            }
        );
    }

    // lazy load scrollers
    ready(function() {
        const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

        if (reducedMotionQuery && reducedMotionQuery.matches) {
            // reduced motion: don't load scroller
        } else {
            loadScroller();
        }
    });

}());
